export function RedirectParameterController($scope) {

    $scope.makeUneditable = makeUnEditable;

    let originalParameter;
    let onUpdate;
    let onDelete;

    this.$onInit = function () {
        onUpdate = this.onUpdate;
        onDelete = this.onDelete;
        originalParameter = Object.assign({}, this.urlParameter);
        $scope.urlParameter = this.urlParameter;
        $scope.isBeingEdited = false;
    };

    $scope.saveRedirect = function () {
        originalParameter = Object.assign({}, $scope.urlParameter);
        makeUnEditable();
        onUpdate($scope.urlParameter);
    };

    $scope.cancelChanges = function () {
        $scope.urlParameter = Object.assign($scope.urlParameter, originalParameter);
        makeUnEditable();
    };

    $scope.makeEditable = function () {
        $scope.isBeingEdited = true;
    };

    $scope.deleteParameter = function () {
        onDelete();
    };

    function makeUnEditable() {
        $scope.isBeingEdited = false;
    }

}
